exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".trades-example h1 {\n  background-color: purple\n}\n\n.w-100{\n  width:100%;\n}\n.clear-btn{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.clear-btn btn{\n  margin-bottom: 0;\n  margin-right: 20px;\n}\n.float-e-margins .button-section .btn {\n  margin-bottom: 0;\n  margin-top: 6px;\n}\n.mt-15{\n  margin-top: 15px;\n}\n.pt-15{\n  padding-top: 15px;\n}\n.select-aria{\n  padding: 6px;\n}\n.table-btn{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom:15px ;\n}\n.table-btn .btn-info {\n  margin-right: 30px;\n  padding: 6px 17px;\n}\n\n.table-btn .btn-danger {\n  padding: 6px 19px;\n}\n\n.material-add .table-btn{\n  margin-right: 15px;\n  justify-content: flex-end;\n}\n.material-add .clear-btn {\n    justify-content: flex-start;\n}\n\n.material-add .margin30 {\n  margin-top:30px;\n}\n.currencyinput {\n    border: 1px inset #ccc;\n}\n.currencyinput input {\n    border: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./packages/custom/trades/public/assets/css/trades.css
// module id = 1024
// module chunks = 0